/**
 * Unified User Type System
 * Maps backend user types to frontend categories while maintaining extensibility
 */

// Backend user types (matches backend/app/models/auth.py)
export type BackendUserType = 'individual' | 'fleet' | 'staff' | 'admin';

// Frontend user categories (simplified view)
export type UserCategory = 'rider' | 'staff';

export function isFleetType(userType: string | undefined | null): boolean {
  return userType === 'fleet';
}
